import { MULTIPLE_SELECT } from 'ACTIONS';

export const addMSelectItem = (payload, selected) => ({
    type: MULTIPLE_SELECT,
    payload,
    selected
});
